import { RouterProvider } from 'react-router'
import { captureException } from '@sentry/react'

import { useRtl } from './hooks/useRtl'
import router from './routes'
import { isModuleLoadError } from './utils/errors'

function App() {
  useRtl()
  return (
    <RouterProvider
      router={router}
      onError={(error, { errorInfo }) => {
        // Don't capture 404s or module load errors
        const is404 = error && typeof error === 'object' && 'status' in error && error.status === 404
        const isLoadError = error instanceof Error && isModuleLoadError(error)

        if (!is404 && !isLoadError) {
          captureException(error, {
            extra: { componentStack: errorInfo?.componentStack },
          })
        }
      }}
    />
  )
}

export default App
